import { render } from "./HandbookLeaveApprovals.vue?vue&type=template&id=e686d38e&scoped=true"
import script from "./HandbookLeaveApprovals.vue?vue&type=script&lang=js"
export * from "./HandbookLeaveApprovals.vue?vue&type=script&lang=js"

import "./HandbookLeaveApprovals.vue?vue&type=style&index=0&id=e686d38e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e686d38e"]])

export default __exports__